import React, { useEffect, useState } from "react";
import { MdModeEdit } from "react-icons/md";
import { FiEye, FiPlus, FiTrash2 } from "react-icons/fi";
import CustomDataTable from "../../../Components/Common/CustomDataTable";
import Tooltip from "../../../Components/Common/Tooltip";
import { authAxios } from "../../../Config/config";
import { toast } from "react-toastify";
import IsLoadingHOC from "../../../Components/Common/IsLoadingHOC";
import {
  customStyles,
  filterActiveItems,
  formatText,
  formatViewDate,
  formatWithTimeDate,
} from "../../../Helper/helper";
import { IoMdCloseCircle } from "react-icons/io";
import DatePicker from "react-datepicker"; // Import datepicker for custom date selection
import "react-datepicker/dist/react-datepicker.css"; // Import default datepicker styles
import { format } from "date-fns";
import ViewPostDetails from "./ViewPostDetails";
import DateRangePicker from "../../../Components/Common/DateRangePickerField";
import Pagination from "../../../Components/Common/Pagination";
import Select from "react-select";
import { BiSortAlt2 } from "react-icons/bi";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import { useSearchParams } from "react-router-dom";

const statusType = [
  { label: "Published", value: "PUBLISHED" },
  { label: "Hidden", value: "HIDDEN" },
  { label: "Under Review", value: "UNDER_REVIEW" },
];

const HotTakeList = (props) => {
  const { setLoading } = props;
  const [searchParams, setSearchParams] = useSearchParams();

  const [hotTakeList, setHotTakeList] = useState([]);
  const [viewPostDetails, setViewPostDetails] = useState(false);
  const [editPostId, setEditPostId] = useState(null);

  const [startDate, setStartDate] = useState(() => {
    const from = searchParams.get("date_from");
    return from ? new Date(from) : null;
  });
  const [endDate, setEndDate] = useState(() => {
    const to = searchParams.get("date_to");
    return to ? new Date(to) : null;
  });

  const [tribeList, setTribeList] = useState([]);
  const [statusFilter, setStatusFilter] = useState(
    () => searchParams.get("status") || null,
  );
  const [userIdFromUrl] = useState(() => searchParams.get("user_id"));
  const [filterUserNameGroup, setFilterUserNameGroup] = useState(null);
  const [tribeGroupIdFromUrl] = useState(() =>
    searchParams.get("circle_group_id"),
  );
  const [tribeIdFromUrl] = useState(() => searchParams.get("circle_id"));

  const [filterTribeGroup, setFilterTribeGroup] = useState(null);
  const [filterTribe, setFilterTribe] = useState(null);

  const [sortBy, setSortBy] = useState(null); // 'likes_count' | 'comments_count'
  const [sortOrder, setSortOrder] = useState("DESC"); // 'DESC' | 'ASC'

  const [tribeGroupOptions, setTribeGroupOptions] = useState([]);
  const [tribeOptions, setTribeOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);

  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const fetchHotTakeList = async (currentPage = page) => {
    try {
      setLoading(true);

      const params = {
        page: currentPage,
        limit: rowsPerPage,
        type: "POST",
      };

      if (statusFilter) {
        params.status = statusFilter;
      }

      if (filterUserNameGroup?.value) {
        params.user_id = filterUserNameGroup.value;
      }

      if (filterTribeGroup?.value) {
        params.circle_group_id = filterTribeGroup.value;
      }

      if (filterTribe?.value) {
        params.circle_id = filterTribe.value;
      }

      if (sortBy) {
        params.sort_by = sortBy;
        params.sort_order = sortOrder;
      }

      if (startDate && endDate) {
        params.date_from = format(startDate, "yyyy-MM-dd");
        params.date_to = format(endDate, "yyyy-MM-dd");
        params.date_filter_field = "created_at";
      }

      const response = await authAxios().get("/post", {
        params,
      });

      const resData = response.data;

      if (resData.success) {
        setHotTakeList(resData.data.items);
        const paginationData = resData.data.pagination;
        setPage(paginationData.page);
        setTotalPages(paginationData.totalPages);
        setTotalCount(paginationData.total);
      } else {
        toast.error(resData.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if ((startDate && !endDate) || (!startDate && endDate)) {
      return;
    }

    fetchHotTakeList(page);
  }, [
    page,
    startDate,
    endDate,
    statusFilter,
    filterTribeGroup,
    filterTribe,
    filterUserNameGroup,
    sortBy,
    sortOrder,
  ]);

  const fetchUsersList = async () => {
    try {
      const params = {
        limit: 5000,
      };
      const response = await authAxios().get("/user", {
        params,
      });
      const resData = response?.data;

      console.log(resData, "resData");

      if (resData?.success) {
        const options = (resData.data.items || []).map((group) => ({
          value: group.id,
          label: group.username,
        }));
        console.log(options, "options");
        setUserOptions(options);
        // NEW: resolve pending user_id from the URL now that we have labels
        if (userIdFromUrl) {
          const match = options.find(
            (o) => String(o.value) === String(userIdFromUrl),
          );
          if (match) setFilterUserNameGroup(match);
        }
      } else {
        toast.error(response.data?.message);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Unable to load tribe groups",
      );
    }
  };

  const fetchTribeGroupList = async () => {
    try {
      const response = await authAxios().get("/tribe-group");
      const resData = response?.data;

      if (resData?.success) {
        const options = (resData.data.items || []).map((group) => ({
          value: group.id,
          label: group.name,
        }));
        console.log(options, "options");
        setTribeGroupOptions(options);
        // NEW: resolve pending tribe-group id from the URL
      if (tribeGroupIdFromUrl) {
        const match = options.find(
          (o) => String(o.value) === String(tribeGroupIdFromUrl),
        );
        if (match) setFilterTribeGroup(match);
      }
      } else {
        toast.error(response.data?.message);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Unable to load tribe groups",
      );
    }
  };

  const fetchTribeList = async (circleGroupId) => {
    try {
      const response = await authAxios().get("/tribe", {
        params: {
          circle_group_id: circleGroupId,
        },
      });

      const resData = response?.data;

      if (resData?.success) {
        const options = (resData.data.items || []).map((tribe) => ({
          value: tribe.id,
          label: tribe.name,
        }));

        setTribeOptions(options);

        // NEW: resolve pending tribe id from the URL, but only the very
        // first time (once resolved, normal setFilterTribe(null) resets
        // on subsequent group changes should win instead).
        if (tribeIdFromUrl && !filterTribe) {
          const match = options.find(
            (o) => String(o.value) === String(tribeIdFromUrl),
          );
          if (match) {
            setFilterTribe(match);
            return;
          }
        }
        setFilterTribe(null);
      } else {
        toast.error(resData?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Unable to load tribes");
    }
  };

  useEffect(() => {
    if (filterTribeGroup?.value) {
      fetchTribeList(filterTribeGroup.value);
      setFilterTribe(null); // Clear previous selection
    } else {
      setTribeOptions([]);
      setFilterTribe(null);
    }
  }, [filterTribeGroup]);

  useEffect(() => {
    fetchTribeGroupList();
    fetchUsersList();
  }, []);

  useEffect(() => {
  const params = new URLSearchParams(searchParams);

  if (statusFilter) params.set("status", statusFilter);
  else params.delete("status");

  if (filterUserNameGroup?.value)
    params.set("user_id", filterUserNameGroup.value);
  else params.delete("user_id");

  if (filterTribeGroup?.value)
    params.set("circle_group_id", filterTribeGroup.value);
  else params.delete("circle_group_id");

  if (filterTribe?.value) params.set("circle_id", filterTribe.value);
  else params.delete("circle_id");

  if (startDate && endDate) {
    params.set("date_from", format(startDate, "yyyy-MM-dd"));
    params.set("date_to", format(endDate, "yyyy-MM-dd"));
  } else {
    params.delete("date_from");
    params.delete("date_to");
  }

  setSearchParams(params, { replace: true });
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [statusFilter, filterUserNameGroup, filterTribeGroup, filterTribe, startDate, endDate]);

  const groupOptions = tribeList.map((group) => ({
    value: group.id,
    label: group.name,
  }));

  const handleDateRangeChange = ({ startDate: newStart, endDate: newEnd }) => {
    setStartDate(newStart);
    setEndDate(newEnd);
    setPage(1);
  };

  const handleStatusChange = (option) => {
    setPage(1);
    setStatusFilter(option?.value || null);
  };

  const handleTribeGroupChange = (option) => {
    setFilterTribeGroup(option);
    setFilterTribe(null);
    setPage(1);
  };

  const handleUserNameChange = (option) => {
    setFilterUserNameGroup(option);
    setPage(1);
  };

  const handleTribeChange = (option) => {
    setFilterTribe(option);
    setPage(1);
  };

  const handleSortToggle = (column) => {
    setPage(1);
    if (sortBy === column) {
      // same column clicked again -> flip order
      setSortOrder((prev) => (prev === "DESC" ? "ASC" : "DESC"));
    } else {
      // new column -> default to DESC
      setSortBy(column);
      setSortOrder("DESC");
    }
  };

  return (
    <>
      <div className="space-y-6">
        <div className="flex justify-between gap-4 relative">
          <div className="flex lg:flex-row flex-col gap-2 flex-1">
            <div className="lg:min-w-[200px] lg:w-fit w-full">
              <DateRangePicker
                onChange={handleDateRangeChange}
                defaultPreset="Today"
                panelOffsetTop={100}
                panelOffsetLeft={0}
                value={{ startDate, endDate }}
              />
            </div>

            <div className="min-w-[180px] lg:w-fit w-full">
              <Select
                placeholder="Filter by status"
                value={statusType.find((o) => o.value === statusFilter) || null}
                options={statusType}
                onChange={handleStatusChange}
                isClearable
                styles={customStyles}
              />
            </div>
            <div className="min-w-[180px] lg:w-fit w-full">
              <Select
                value={filterUserNameGroup}
                options={userOptions}
                onChange={handleUserNameChange}
                styles={customStyles}
                placeholder="Filter by Username"
                isClearable
              />
            </div>
            <div className="min-w-[180px] lg:w-fit w-full">
              <Select
                value={filterTribeGroup}
                options={tribeGroupOptions}
                onChange={handleTribeGroupChange}
                styles={customStyles}
                placeholder="Select Tribe Group"
                isClearable
              />
            </div>

            <div className="min-w-[170px] lg:w-fit w-full">
              <Select
                value={filterTribe}
                options={tribeOptions}
                onChange={handleTribeChange}
                styles={customStyles}
                placeholder="Select Tribe"
                isClearable
                isDisabled={!filterTribeGroup}
              />
            </div>
          </div>
        </div>

        <div className="mt-3">
          <div className="box--shadow bg-white rounded-[15px] p-4">
            <div className="relative overflow-x-auto">
              <table className="w-full text-sm text-left text-gray-500">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                  <tr>
                    <th className="px-2 py-4 min-w-[120px]">Created Date</th>

                    <th className="px-2 py-4 min-w-[100px]">Content ID</th>
                    <th className="px-2 py-4 min-w-[100px]">Username</th>
                    <th className="px-2 py-4 min-w-[100px]">Tribe Group</th>
                    <th className="px-2 py-4 min-w-[170px]">Tribe Name</th>
                    <th className="px-2 py-4 min-w-[150px]">Title</th>
                    <th className="px-2 py-4 min-w-[150px] text-center">
                      Status
                    </th>
                    <th
                      className="px-2 py-4 min-w-[80px] text-center cursor-pointer select-none"
                      onClick={() => handleSortToggle("likes_count")}
                    >
                      <div className="flex gap-2 justify-center align-center">
                        <span>Likes</span>
                        <span>
                          {sortBy === "likes_count" ? (
                            sortOrder === "DESC" ? (
                              <TiArrowSortedDown size={15} />
                            ) : (
                              <TiArrowSortedUp size={15} />
                            )
                          ) : (
                            <BiSortAlt2 size={15} />
                          )}
                        </span>
                      </div>
                    </th>
                    <th
                      className="px-2 py-4 min-w-[100px] text-center cursor-pointer select-none"
                      onClick={() => handleSortToggle("comments_count")}
                    >
                      <div className="flex gap-2 justify-center align-center">
                        <span>Comments</span>
                        <span>
                          {sortBy === "comments_count" ? (
                            sortOrder === "DESC" ? (
                              <TiArrowSortedDown size={15} />
                            ) : (
                              <TiArrowSortedUp size={15} />
                            )
                          ) : (
                            <BiSortAlt2 size={15} />
                          )}
                        </span>
                      </div>
                    </th>

                    <th className="px-2 py-4 min-w-[100px] text-center">
                      Actions
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {hotTakeList?.length > 0 ? (
                    hotTakeList.map((row, index) => (
                      <tr
                        key={row.id || index}
                        className="border-b hover:bg-gray-50 text-xs"
                      >
                        <td className="px-2 py-4">
                          {formatViewDate(row.created_at)}
                        </td>

                        <td className="px-2 py-4">{row.content_id || "-"}</td>
                        <td className="px-2 py-4">
                          {row.user?.username || "-"}
                        </td>
                        <td className="px-2 py-4">
                          {row.circle?.circleGroup?.name || "-"}
                        </td>
                        <td className="px-2 py-4">{row.circle?.name || "-"}</td>
                        <td className="px-2 py-4">{row.title || "-"}</td>

                        <td className="px-2 py-4 text-center">
                          <span
                            className={`px-3 py-1 rounded-full text-xs font-medium ${
                              {
                                PUBLISHED: "bg-green-100 text-green-700",
                                UNDER_REVIEW: "bg-blue-100 text-blue-700",
                                HIDDEN: "bg-gray-200 text-gray-700",
                                DELETED: "bg-red-100 text-red-700",
                                BANNED: "bg-yellow-100 text-yellow-700",
                              }[row.status] || "bg-gray-100 text-gray-600"
                            }`}
                          >
                            {formatText(row.status)}
                          </span>
                        </td>

                        {/* <td className="px-2 py-4 text-center">
                          {row.is_pinned ? "Yes" : "No"}
                        </td> */}

                        <td className="px-2 py-4 text-center">
                          {row.likes_count}
                        </td>

                        <td className="px-2 py-4 text-center">
                          {row.comments_count}
                        </td>

                        {/* <td className="px-2 py-4">
                          {row.user?.name || "-"}
                        </td> */}

                        <td className="px-2 py-4">
                          <div className="flex items-center justify-center">
                            <Tooltip
                              id={`tooltip-view-${row.id}`}
                              content="View"
                              place="left"
                            >
                              <button
                                onClick={() => {
                                  setEditPostId(row.id);
                                  setViewPostDetails(true);
                                }}
                                className="text-black bg-gray-100 w-[30px] h-[30px] flex items-center justify-center rounded-md"
                              >
                                <FiEye size={18} />
                              </button>
                            </Tooltip>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={12}
                        className="px-4 py-6 text-center text-gray-500"
                      >
                        No records found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            <Pagination
              page={page}
              totalPages={totalPages}
              rowsPerPage={rowsPerPage}
              totalCount={totalCount}
              currentDataLength={hotTakeList.length}
              onPageChange={(newPage) => {
                setPage(newPage);
                fetchHotTakeList(newPage);
              }}
            />
          </div>
        </div>
      </div>

      <ViewPostDetails
        open={viewPostDetails}
        onClose={() => {
          setViewPostDetails(false);
          setEditPostId(null);
        }}
        editId={editPostId}
        onSuccess={() => fetchHotTakeList()}
      />
    </>
  );
};

export default IsLoadingHOC(HotTakeList);
